const PlayIcon = () => {
    return (
        <svg aria-hidden="true" focusable="false" width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 2.38254C0 0.861336 1.63093 -0.102987 2.96384 0.630111L16.8138 8.24757C18.1953 9.00742 18.1953 10.9926 16.8138 11.7524L2.96384 19.3699C1.63093 20.103 0 19.1387 0 17.6175V2.38254Z" fill="white" />
        </svg>
    );
};

const ViewsIcon = (props) => {
    const fillColor = props.fillColor ? props.fillColor : 'white';
    const opacity = fillColor === 'white' ? '0.9' : '0.6';

    return (
        <svg aria-hidden="true" focusable="false" width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g opacity={opacity}>
                <path d="M7.99996 6.5C7.46953 6.5 6.96082 6.71071 6.58575 7.08579C6.21067 7.46086 5.99996 7.96957 5.99996 8.5C5.99996 9.03043 6.21067 9.53914 6.58575 9.91421C6.96082 10.2893 7.46953 10.5 7.99996 10.5C8.53039 10.5 9.0391 10.2893 9.41417 9.91421C9.78925 9.53914 9.99996 9.03043 9.99996 8.5C9.99996 7.96957 9.78925 7.46086 9.41417 7.08579C9.0391 6.71071 8.53039 6.5 7.99996 6.5ZM7.99996 11.8333C7.1159 11.8333 6.26806 11.4821 5.64294 10.857C5.01782 10.2319 4.66663 9.38406 4.66663 8.5C4.66663 7.61595 5.01782 6.7681 5.64294 6.14298C6.26806 5.51786 7.1159 5.16667 7.99996 5.16667C8.88401 5.16667 9.73186 5.51786 10.357 6.14298C10.9821 6.7681 11.3333 7.61595 11.3333 8.5C11.3333 9.38406 10.9821 10.2319 10.357 10.857C9.73186 11.4821 8.88401 11.8333 7.99996 11.8333ZM7.99996 3.5C4.66663 3.5 1.81996 5.57333 0.666626 8.5C1.81996 11.4267 4.66663 13.5 7.99996 13.5C11.3333 13.5 14.18 11.4267 15.3333 8.5C14.18 5.57333 11.3333 3.5 7.99996 3.5Z" fill={fillColor} />
            </g>
        </svg>
    );
}

const LikesIcon = (props) => {
    const fillColor = props.fillColor ? props.fillColor : 'white';
    const opacity = fillColor === 'white' ? '0.9' : '0.6';

    return (
        <svg aria-hidden="true" focusable="false" width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path opacity={opacity} d="M7.1123 12.6313C6.92822 12.6313 6.66162 12.4854 6.42676 12.333C2.89746 10.0479 0.618652 7.35645 0.618652 4.63965C0.618652 2.24023 2.28174 0.589844 4.33203 0.589844C5.60791 0.589844 6.55371 1.30078 7.1123 2.33545C7.67725 1.29443 8.62305 0.589844 9.89893 0.589844C11.9429 0.589844 13.606 2.24023 13.606 4.63965C13.606 7.35645 11.3271 10.0479 7.8042 12.333C7.56934 12.4854 7.29639 12.6313 7.1123 12.6313Z" fill={fillColor} />
        </svg>
    );
}

const TikTokIcon = () => {
    return (
        <svg aria-hidden="true" focusable="false" width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.3626 4.78024C12.2749 4.73489 12.1895 4.68518 12.1067 4.63129C11.866 4.47217 11.6453 4.28468 11.4494 4.07285C10.9592 3.51199 10.7762 2.94299 10.7087 2.54462H10.7114C10.6551 2.21395 10.6784 2 10.6819 2H8.44929V10.6332C8.44929 10.7491 8.44929 10.8637 8.44441 10.9769C8.44441 10.9909 8.44306 11.0039 8.44225 11.0191C8.44225 11.0253 8.44225 11.0318 8.44089 11.0383C8.44089 11.04 8.44089 11.0416 8.44089 11.0432C8.41736 11.353 8.31806 11.6522 8.15174 11.9146C7.98542 12.177 7.75717 12.3944 7.48707 12.5479C7.20556 12.708 6.88717 12.792 6.5633 12.7916C5.52308 12.7916 4.68002 11.9434 4.68002 10.8959C4.68002 9.84836 5.52308 9.00015 6.5633 9.00015C6.76021 8.99997 6.9559 9.03095 7.14313 9.09196L7.14583 6.8187C6.57748 6.74528 6.00008 6.79045 5.45006 6.95136C4.90004 7.11226 4.38933 7.38541 3.95016 7.75357C3.56534 8.08792 3.24182 8.48687 2.99417 8.93245C2.89992 9.09494 2.54433 9.74788 2.50127 10.8076C2.47419 11.4091 2.65483 12.0322 2.74095 12.2898V12.2952C2.79511 12.4469 3.005 12.9644 3.34704 13.4007C3.62286 13.7507 3.94872 14.0581 4.31414 14.3131V14.3077L4.31956 14.3131C5.4004 15.0476 6.59878 14.9994 6.59878 14.9994C6.80623 14.991 7.50115 14.9994 8.29032 14.6253C9.16561 14.2107 9.66392 13.593 9.66392 13.593C9.98226 13.2239 10.2354 12.8032 10.4125 12.3491C10.6145 11.818 10.6819 11.1811 10.6819 10.9265V6.34639C10.709 6.36264 11.0697 6.60123 11.0697 6.60123C11.0697 6.60123 11.5894 6.93434 12.4003 7.15126C12.982 7.30563 13.7658 7.33813 13.7658 7.33813V5.12174C13.4911 5.15153 12.9335 5.06487 12.3626 4.78024Z" fill="#696D80" />
        </svg>
    );
}

const PreviousIcon = ({
    style = {}, className = '',
}) => {
    return (
        <svg aria-hidden="true" focusable="false" className={className} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" style={style}>

            <g >
                <path d="M10 16.6673L3.33334 10.0007L10 3.33398L11.1875 4.50065L6.52084 9.16732H16.6667V10.834H6.52084L11.1875 15.5007L10 16.6673Z" fill="#2C324C" />
            </g>
        </svg>
    )
};

const NextIcon = ({
    style = {}, className = '',
}) => {
    return (
        <svg aria-hidden="true" focusable="false" className={className} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" style={style}>

            <g>
                <path d="M10 16.6673L8.81254 15.5007L13.4792 10.834H3.33337V9.16732H13.4792L8.81254 4.50065L10 3.33398L16.6667 10.0007L10 16.6673Z" fill="#2C324C" />
            </g>
        </svg>
    )
}

const CloseIcon = () => {
    return(
        <svg aria-hidden="true" focusable="false" width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19.5 6.41L18.09 5L12.5 10.59L6.91 5L5.5 6.41L11.09 12L5.5 17.59L6.91 19L12.5 13.41L18.09 19L19.5 17.59L13.91 12L19.5 6.41Z" fill="#434960" />
        </svg>
    );
};

/* ── Swipe View glyph set ───────────────────────────────────────────────────
 *
 * SMASH-1853, team feedback 2026-08-24: "match TikTok's native player as
 * closely as possible". ONE place to swap a glyph — the path data below is
 * plain data, and the four components after it are thin renderers over it, so
 * re-pointing a glyph at a different icon set is a one-line edit HERE rather
 * than surgery across SwipeView.jsx. (The icon set gets its own design review
 * next; that review should not have to read JSX.)
 *
 * Nothing here adds a dependency. A new runtime dep in this bundle needs an
 * AgDR of its own — see the SMASH-1836 bundle-size work — so `react-icons` and
 * friends are deliberately out of scope; path data is copied/authored inline.
 *
 * Provenance, stated explicitly per glyph:
 *   - `play` / `pause`: the canonical Material Icons `play_arrow` / `pause`
 *     paths (Apache-2.0, github.com/google/material-design-icons). Filled and
 *     sharp-cornered on a 24x24 grid — the same shape language TikTok's own
 *     player uses for its centre play/pause flash. The viewer previously drew
 *     pause as two rounded `<rect>`s (rx=1) on a 16x18 grid, which read softer
 *     and lighter than the native control next to it.
 *   - `soundOn` / `soundOff`, `like`, `comment`, `share`, `close`: the
 *     REFERENCE DESIGN's own paths, taken verbatim from the measured spec's
 *     Appendix A (A.1 for close, A.3 for the rest) in the 2026-09-08 restyle.
 *     They were hand-authored here before that, on the same 24x24 grid,
 *     following Material's `volume_up` / `volume_off` shape language.
 *
 *     Reproduced as path DATA rather than redrawn, per the ratified glyph rule:
 *     a long path reproduced from memory is subtly wrong in ways only a render
 *     reveals, and attributing a memory-reproduced path to a licensed set would
 *     be a provenance claim nobody can stand behind.
 *
 *     The swap RETIRED two derivations along with the drawings, which is worth
 *     knowing before anyone reintroduces them. Our muted glyph was a slash cut
 *     through the cone, and it needed both a dark backing stroke (a white line
 *     over a white cone is invisible exactly where it must be legible) and
 *     endpoints pulled in by the cap radius — a round-capped stroke paints
 *     `strokeWidth / 2` past each end, so without that soundOff measured 17.5
 *     units tall against soundOn's 15 and read visibly bigger than its own twin
 *     one tap away. The design's pair is fully FILLED, TikTok's own idiom, so
 *     there is no cap and no backing stroke and nothing left to keep in sync.
 *     Our comment bubble carried a similar note about arc chords; the design's
 *     keeps the evenodd dot cutouts on its own geometry.
 *
 *     Every one of these is `currentColor` rather than a hardcoded white,
 *     because two call sites need different colours: the mute button INVERTS
 *     its paint (dark glyph on a white chip while muted), and a dimmed or
 *     disabled control has to carry its glyph down with it.
 *
 * ONE DELIBERATE HOLDOUT, so the set is not mistaken for complete:
 * `SwipeTikTokIcon` stays a standalone component rather than joining this
 * object, because it is the brand MARK — a logo, not an icon. Its path is the
 * design's own tracing and it must not be redrawn.
 */

const SWIPE_GLYPHS = {
    play: [{ d: 'M8 5v14l11-7z', fill: 'white' }],
    pause: [{ d: 'M6 19h4V5H6v14zm8-14v14h4V5h-4z', fill: 'white' }],
    /*
     * ── The sound pair: Appendix A.3, verbatim ──────────────────────────────
     *
     * REPLACES a hand-authored stroked pair, and the swap is a real change of
     * idiom rather than a tidy-up. Ours drew a filled cone plus two STROKED
     * flare arcs for the unmuted state, and a slash with a dark backing stroke
     * under it for muted — the backing existed because a white line over a
     * white cone is invisible exactly where it has to be legible.
     *
     * The design's set is fully FILLED, which is TikTok's own idiom, and it
     * needs no backing trick: the muted glyph is a cone plus a filled cross
     * drawn beside it rather than a slash cut through it. That also retires the
     * derivation the old pair needed — the slash's endpoints were pulled in by
     * the cap radius so soundOff would not measure taller than soundOn, since a
     * round-capped stroke paints `strokeWidth / 2` past each end. A filled path
     * has no cap, so there is nothing left to keep in sync.
     *
     * `currentColor`, not `white`: rule 1.6 inverts this button's paint —
     * solid white with a DARK glyph while muted, dark translucent with a white
     * glyph once sound is on. A hardcoded white glyph would be invisible
     * against the muted state's white chip.
     */
    soundOn: [
        { d: 'M3 9v6h4l5 4V5L7 9H3z', fill: 'currentColor' },
        { d: 'M16.5 12a4.5 4.5 0 0 0-2.5-4.03v8.05A4.5 4.5 0 0 0 16.5 12zM14 3.23v2.06A7 7 0 0 1 14 18.7v2.07A9 9 0 0 0 14 3.23z', fill: 'currentColor' },
    ],
    soundOff: [
        { d: 'M3 9v6h4l5 4V5L7 9H3z', fill: 'currentColor' },
        { d: 'm16.3 8.9-1.4 1.4 1.7 1.7-1.7 1.7 1.4 1.4 1.7-1.7 1.7 1.7 1.4-1.4-1.7-1.7 1.7-1.7-1.4-1.4-1.7 1.7z', fill: 'currentColor' },
    ],
    close: [{ d: 'M6 6l12 12M18 6L6 18', stroke: 'currentColor', strokeWidth: 2.4 }],
    /*
     * ── The rail trio: Appendix A.3, verbatim ───────────────────────────────
     *
     * All three replaced in the 2026-09-08 restyle, and the comment glyph's
     * replacement retires a derivation worth recording rather than deleting
     * silently.
     *
     * Ours drew the bubble with its three dots CUT OUT under `fill-rule:
     * evenodd` — the dots were closed subpaths whose crossing parity put them
     * outside the fill, so they read as holes and the gradient behind showed
     * through. It also used a two-arc circle idiom on a HORIZONTAL chord,
     * because a vertical chord exactly equal to the diameter is where float
     * error makes a UA silently rescale the radius.
     *
     * The design's bubble keeps the evenodd dot cutouts (so the mechanism is
     * the same idea) but expresses the dots as `a1.4 1.4 0 1 1 0-2.8` arcs on
     * its own geometry. Reproduced as path DATA rather than re-derived: the
     * ratified glyph rule exists because a long path reproduced from memory is
     * subtly wrong in ways only a render reveals.
     *
     * `currentColor` throughout, so the rail's circles and the touch layout's
     * bare glyphs can differ in colour without a second copy of the set.
     */
    like: [{ d: 'M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z', fill: 'currentColor' }],
    comment: [{ d: 'M12 2C6.48 2 2 5.9 2 10.7c0 2.6 1.3 4.93 3.36 6.53L4.3 21.4a.6.6 0 0 0 .87.66l4.1-2.3c.87.2 1.78.3 2.73.3 5.52 0 10-3.9 10-8.7S17.52 2 12 2zM7.5 12.2a1.4 1.4 0 1 1 0-2.8 1.4 1.4 0 0 1 0 2.8zm4.5 0a1.4 1.4 0 1 1 0-2.8 1.4 1.4 0 0 1 0 2.8zm4.5 0a1.4 1.4 0 1 1 0-2.8 1.4 1.4 0 0 1 0 2.8z', fill: 'currentColor', fillRule: 'evenodd' }],
    share: [{ d: 'M13.5 3.6a1 1 0 0 1 1.66-.75l7.5 6.6a1 1 0 0 1 0 1.5l-7.5 6.6a1 1 0 0 1-1.66-.75v-3.3c-4.1.1-7.2 1.5-9.6 4.6-.4.5-1.2.2-1.1-.4C3.7 12.6 7.4 8.6 13.5 7.9V3.6z', fill: 'currentColor' }],
};

/*
 * Presentation only, in every case: `aria-hidden` + `focusable="false"` means
 * the glyph contributes nothing to the accessible name. Each call site's own
 * `aria-label` (and, for the sound toggle, its Mute/Unmute switch driven by
 * real sampled state) is the whole a11y story — swapping a glyph must never
 * change it.
 *
 * `viewBox` defaults to the 24x24 grid every SWIPE_GLYPHS entry is drawn on, and
 * is a parameter only so the 20x20 hint set below can share this renderer
 * instead of copying it. Callers on the 24 grid pass nothing and are unaffected.
 *
 * `strokeLinejoin` is unconditional, and is a NO-OP for the 24-grid set: every
 * stroked path in SWIPE_GLYPHS is a single segment or a single arc (the close
 * cross is two separate subpaths, the soundOn flares are one arc each, the
 * soundOff slash is one line), and a path with no corner has no join to round.
 * The 20-grid set genuinely needs it — its rounded rectangle, cursor outline and
 * speaker body all have corners, and at `miter` the cursor's sharp points throw
 * spikes well past the glyph's own bounds.
 */
const SwipeGlyph = ({ paths, size, viewBox = '0 0 24 24' }) => {
    return (
        <svg aria-hidden="true" focusable="false" width={size} height={size} viewBox={viewBox} fill="none" xmlns="http://www.w3.org/2000/svg">
            {paths.map((p, i) => (
                <path
                    key={i}
                    d={p.d}
                    fill={p.fill || 'none'}
                    fillRule={p.fillRule}
                    stroke={p.stroke}
                    strokeWidth={p.strokeWidth}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            ))}
        </svg>
    );
};

// Centre tap-flash pair. 28px inside the 64px `.sbtt-swipeview-tapflash-glyph`
// disc — the old 18x20 / 16x18 glyphs looked lost in it next to TikTok's own,
// which fills far more of its disc. The DISC geometry is untouched.
const SwipePlayIcon = () => <SwipeGlyph paths={SWIPE_GLYPHS.play} size={28} />;
const SwipePauseIcon = () => <SwipeGlyph paths={SWIPE_GLYPHS.pause} size={28} />;

// The top row's mute button (rule 1.6) — it was the rail's sound toggle until
// the 2026-09-08 restyle moved it. Named for the STATE each one depicts, not the
// action that leaves it: `chrome.muted ? <SwipeSoundOffIcon/> : <SwipeSoundOnIcon/>`
// reads as obviously correct, where the old `MuteIcon`-when-muted pairing did not.
// 22 -> 20px, the design's own glyph size inside its 34px chip.
const SwipeSoundOffIcon = () => <SwipeGlyph paths={SWIPE_GLYPHS.soundOff} size={20} />;
const SwipeSoundOnIcon = () => <SwipeGlyph paths={SWIPE_GLYPHS.soundOn} size={20} />;

// Swipe View chrome. `CloseIcon` and `TikTokIcon` above are both dark-fill
// (#434960 / #696D80), tuned for the classic lightbox's light-background
// close/CTA buttons (Modal.jsx). The swipe viewer's chrome sits on translucent
// circles over a black frame — a dark-fill icon there is close to invisible —
// so these are swipe-scoped siblings rather than edits to the shared icons
// (which stay correct for Modal.jsx's light context).
//
// 16 -> 22px in the 2026-09-08 restyle, with the path re-gridded to Appendix
// A.1's `M6 6l12 12M18 6L6 18` at stroke 2.4. The old 16px glyph was sized to
// sit inside a 30px painted `::before` disc, which existed so the button could
// show 30px of paint while keeping a 44px hit box. Rule 1.4 replaces that whole
// arrangement with a single 40x40 painted button, so the glyph is sized to the
// design's own 22px and the ::before disc is gone.
const SwipeCloseIcon = () => <SwipeGlyph paths={SWIPE_GLYPHS.close} size={22} />;

/*
 * The TikTok brand mark — a LOGO, not an icon, so it is reproduced and never
 * restyled. Appendix A.3's `logo` path, on the shared 24x24 grid.
 *
 * Re-gridded from a 16x17 viewBox in the 2026-09-08 restyle. The old path was a
 * different tracing of the same mark, carried over from the classic lightbox's
 * CTA; using the design's own means the pill in the viewer and the mark in
 * Aman's reference are the same artwork rather than two drawings that agree
 * approximately.
 *
 * `currentColor` so the pill's own colour drives it — the mark sits on a dark
 * translucent pill in the top row and on a bare glyph in the touch rail, and
 * those are different colours.
 */
const SwipeTikTokIcon = () => {
    return (
        <svg aria-hidden="true" focusable="false" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" fill="currentColor" />
        </svg>
    );
};

/*
 * Desktop-only up/down nav (rail), like TikTok web's chevron controls.
 *
 * The y coordinates are INSET BY THE CAP RADIUS, and that is the whole reason
 * they are 8.5/1.5 rather than the 9/2 they shipped as (maintainer review
 * 2026-08-27: "the chevron glyphs are not centred in their discs").
 *
 * A round-capped, round-joined stroke paints every point within `strokeWidth/2`
 * of the polyline — so the painted box is the polyline's own bounds widened by
 * the cap radius on ALL FOUR sides, at the apex exactly as much as at the two
 * open ends. The old `M1 9L8 2L15 9` put its endpoints hard on the viewBox's
 * bottom edge (y9 of 10) while the apex sat two units off the top, so the 1 unit
 * of cap budget was spent past the bottom edge and the remaining slack all
 * collected above the glyph: painted 1..10 of a 0..10 box, ink centre 5.5
 * against a box centre of 5. The disc's flex centring was never at fault — it
 * centres the SVG BOX perfectly; the ink was off-centre inside that box.
 *
 * Because the two glyphs lean opposite ways the error was mirrored, not shared:
 * up painted 0.5px low, down painted 0.5px high, leaving the pair 1px closer
 * together than their discs — which is what made a half-pixel visible, since the
 * eye compares two adjacent discs rather than judging one in isolation.
 *
 * Insetting to 8.5/1.5 spends the cap radius INSIDE the box on both sides:
 * painted 0.5..9.5, ink centre exactly 5, and the two glyphs become exact
 * mirrors with identical painted extents. The 45-degree lean is untouched (dx 7,
 * dy 7, as before) and so is the 16x10 grid, the 2px weight and the ink's own
 * 16x9 size — the glyph moves, it does not resize or re-grid.
 *
 * Measured, not eyeballed: rasterised in Chromium at a 20x device scale factor
 * inside a replica of the real 44px disc, and the ink's bounding box read back
 * off the pixels. Before: centre 22.0,22.5 (up) and 22.0,21.5 (down) against the
 * disc's 22,22. After: 22,22 for both. Re-derived from these attributes on every
 * run by the centring test in SwipeView.chrome.test.js, so a future change to
 * the stroke width or the grid fails CI instead of quietly re-introducing the
 * offset — the cap radius is a term in that arithmetic, not a constant.
 */
/*
 * TikTok's verified badge (spec Appendix A.3). A filled circle with a white
 * check knocked into it — the circle takes `currentColor` so the CSS supplies
 * the brand cyan (`#20d5ec`), while the check is a literal `#fff` because it
 * must stay white whatever colour the badge becomes.
 *
 * `role="img"` with a name rather than `aria-hidden`, because unlike every
 * other glyph in this file this one carries INFORMATION rather than decorating
 * a control that already has a name. It sits inside the handle link, so
 * "@creator, Verified" is the whole point of rendering it.
 *
 * 15px, the design's own size in the author row.
 */
const SwipeVerifiedIcon = () => {
    return (
        <svg className="sbtt-swipeview-verified" role="img" aria-label="Verified" width="15" height="15" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="11" fill="currentColor" />
            <path fill="#fff" d="M10.2 16.6 5.9 12.3l1.6-1.6 2.7 2.7 6.3-6.3 1.6 1.6z" />
        </svg>
    );
};

/*
 * The first-run coach overlay's hand (rule 1.9, spec Appendix A.1).
 *
 * An upward arrow through a fingertip, on its own 44x64 grid rather than the
 * shared 24x24 one — it is a pictogram rather than a control's glyph, and the
 * design draws it at that aspect.
 *
 * `#fff` literal rather than `currentColor`, deliberately and unlike every other
 * glyph in this file: the overlay it sits in has one fixed treatment (white on a
 * 35% black scrim) and no state to track, so there is nothing for a colour token
 * to follow. The filled circle is the fingertip and must stay solid while the
 * arrow stays stroked, which one `currentColor` could not express anyway.
 */
const SwipeCoachHandIcon = () => {
    return (
        <svg aria-hidden="true" focusable="false" width="44" height="64" viewBox="0 0 44 64" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M22 6v30" stroke="#fff" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M12 16l10-10 10 10" stroke="#fff" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
            <circle cx="22" cy="52" r="6" fill="#fff" />
        </svg>
    );
};

/*
 * Swipe View chevrons — RE-GRIDDED to the reference design's own 24x24 pair
 * (spec Appendix A.1), 2026-09-08 restyle.
 *
 * What changed and why it is a re-grid rather than a tweak: these were drawn on
 * a 16x10 grid at stroke 2, with the y coordinates inset by the cap radius
 * (8.5/1.5 rather than 9/2) to stop the round caps painting past the viewBox and
 * throwing the ink off-centre inside its own box. That correction was right for
 * that grid and is unnecessary on this one — the design's paths sit at y6..y15
 * inside a 24-unit box, so there are 6 units of slack above and below and the
 * 1.1-unit cap radius has nowhere to overflow to. Ink centre is exactly 12 on
 * both, and the two glyphs are exact mirrors, which is what the eye actually
 * judges when it compares two adjacent discs.
 *
 * `currentColor`, not `white`: the design drives every round control's glyph
 * from the button's own `color`, which is what lets a disabled chevron dim via
 * `opacity` on the button and keeps the glyph in step with it. A hardcoded
 * `white` would survive the dim and read brighter than the disc it sits on.
 *
 * Rendered at 24x24 by CSS in the rail column; stroke 2.2 with round caps and
 * joins, both verbatim from Appendix A.1. Reproduced as path DATA — not redrawn
 * — per the ratified glyph rule.
 */
const ChevronUpIcon = () => {
    return (
        <svg aria-hidden="true" focusable="false" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 15l6-6 6 6" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
};

const ChevronDownIcon = () => {
    return (
        <svg aria-hidden="true" focusable="false" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 9l6 6 6-6" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
};

// Swipe View interaction counts (SMASH-1853). Filled white at 24px — TikTok's
// own rail language, and uniform in weight with each other, which the plugin's
// tile icons (ViewsIcon 16x17, LikesIcon 14x13) are not. Those stay in use for
// the small views readout in the meta, where their natural size is right.
//
// Re-homed onto SWIPE_GLYPHS in the 2026-08-24 maintainer pass, along with the
// comment glyph's dot cutouts (item 4) — the whole reviewable set now lives in
// one object instead of half of it living down here.
// The rail trio. 24 -> 26px, the design's own glyph size inside its 48px
// circle (TT-2). The touch layout scales them to 32px in CSS rather than
// rendering a second set, so these attributes are the desktop size and the
// stylesheet owns the other.
const SwipeLikeIcon = () => <SwipeGlyph paths={SWIPE_GLYPHS.like} size={26} />;
const SwipeCommentIcon = () => <SwipeGlyph paths={SWIPE_GLYPHS.comment} size={26} />;
const SwipeShareIcon = () => <SwipeGlyph paths={SWIPE_GLYPHS.share} size={26} />;

// 20px, matching the card's 20px icon box exactly — so the ink lands where the
// frame's own pixels put it, with no scaling step to reason about.
export {
    NextIcon,
    PlayIcon,
    ViewsIcon,
    LikesIcon,
    SwipeLikeIcon,
    SwipeCommentIcon,
    SwipeShareIcon,
    TikTokIcon,
    PreviousIcon,
    CloseIcon,
    SwipePlayIcon,
    SwipePauseIcon,
    SwipeSoundOffIcon,
    SwipeSoundOnIcon,
    SwipeCloseIcon,
    SwipeTikTokIcon,
    SwipeVerifiedIcon,
    SwipeCoachHandIcon,
    ChevronUpIcon,
    ChevronDownIcon,
    // Exported for the icon-set review + its regression test: the glyph data is
    // the thing that gets swapped, so it needs to be assertable on its own.
    SWIPE_GLYPHS,
    // Same reason, plus one this set has of its own: it is a design hand-off on a
    // different grid, so "did an edit re-grid or re-draw the export?" has to be
    // assertable without rendering it.
};